module.exports = __webpack_public_path__ + "static/media/team14.8be9cdca.png";